// Version : 1.0.0
// Author : AGALYA

import ResidentialDetailsActionType from './residential-details.types';

/** ***************** Residential Address Add Start ************************/
export const residentialDetailsAddStart = (residentialDetailsCredentials: any) => ({
	type: ResidentialDetailsActionType.RESIDENTIAL_DETAILS_ADD_START,
	payload: residentialDetailsCredentials,
});

export const residentialDetailsAddSuccess = (residentialDetailsSuccess: any) => ({
	type: ResidentialDetailsActionType.RESIDENTIAL_DETAILS_ADD_SUCCESS,
	payload: residentialDetailsSuccess,
});

export const residentialDetailsAddFailure = (residentialDetailsFailure: any) => ({
	type: ResidentialDetailsActionType.RESIDENTIAL_DETAILS_ADD_FAILURE,
	payload: residentialDetailsFailure,
});

export const residentialDetailsAddResponseResetStart = () => ({
	type: ResidentialDetailsActionType.RESIDENTIAL_DETAILS_ADD_RESPONSE_REST_START,
});

export const residentialDetailsAddUserResponseChanged = () => ({
	type: ResidentialDetailsActionType.RESIDENTIAL_DETAILS_ADD_RESPONSE_CHANGED,
});
/** ***************** Residential Address Add End ************************/
